<div id="sub-top">
    <div class="img-wrap">
        <img src="/assets/images/company.png" (load)="afterload()">
        <h2 data-aos="fade-right" data-aos-duration="2000">
            <strong>아이로브는</strong> 끊임없는 노력과 도전정신으로 <br> 우리의 삶의 편안과 행복을 선도하는 소프트웨어
            기업입니다.
        </h2>
    </div>
</div>
<section [ngSwitch]="subPage || 'vision'"> 
    <div class="sub-path">
        <ul >
            <li>회사소개 ></li>
            <li *ngSwitchCase="'location'">오시는 길</li>
            <li *ngSwitchCase="'vision'">비전/경영이념</li>
            <li *ngSwitchCase="'technology'">핵심기술</li>     
            <li *ngSwitchDefault></li>
        </ul>
        <div class="tab">
            <ul>
                <li><a [ngClass]="{'on': subPage === 'vision'}" (click)="subPage='vision'" >비전/경영이념</a></li>
                <li><a [ngClass]="{'on': subPage === 'technology'}" (click)="subPage='technology'">핵심기술</a></li>
                <li><a [ngClass]="{'on': subPage === 'location'}"  (click)="subPage='location'">오시는 길</a></li>
            </ul>

            <!-- select bar -->
            <div *ngSwitchCase="'location'" class="tab-indicator company-location"></div>
            <div *ngSwitchCase="'vision'" class="tab-indicator company-vision"></div>
            <div *ngSwitchCase="'technology'" class="tab-indicator company-technology"></div>
            <div *ngSwitchDefault></div>  
        
        </div>
    </div>

    <!-- sub page -->
    <article *ngSwitchCase="'location'"><app-location></app-location></article>
    <article *ngSwitchCase="'vision'"><app-vision></app-vision></article>
    <article *ngSwitchCase="'technology'"><app-technology [scrollPage] = "scrollPage"></app-technology></article>
    <article *ngSwitchDefault></article>
</section>